export const defaultBreadcrumbSubTitle = [
    {
        text: 'You can set breadcrumb using ',
        code: '.breadcrumb '
    },
    {
        text: ' class.'
    }
]

export const dividerBreadcrumbSubTitle = [
    {
        text: 'You can set breadcrumb using ',
        code: '.breadcrumb-icon'
    },
    {
        text: ' class.'
    }
]

export const withIconBreadcrumbSubTitle = [
    {
        text: 'You can set icons breadcrumb using ',
        code: '.breadcrumb '
    },
    {
        text: 'class.'
    }
]

export const variationBreadcrumbSubTitle = [
    {
        text: 'You can set variations breadcrumb using ',
        code: '.breadcrumb '
    },
    {
        text: 'class through any icons sets.'
    }
]

export const colorBreadcrumbSubTitle = [
    {
        text: 'You can set breadcrumb using ',
        code: '.breadcrumb '
    },
    {
        text: ' class and set background colors like ',
        code: '[.bg-*].'
    }
];

export const coloredBreadcrumbData = [
    {
        id: 1,
        color: 'primary',
        item : ['Home','Bonus Ui','Breadcrumb']
    },
    {
        id: 2,
        color: 'warning',
        item : ['Home','Icons','Flag-icon']
    },
    {
        id: 3,
        color: 'secondary',
        item : ['Home','Gallery','Gallery-grid']
    },
]